import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    PictureUpload,
    LabeledTextView,
} from '../../components/Form';


import {
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

// Custom DataTable component for displaying tabular data
const DataTable = ({ columns, data, pagination = false }) => {
    const formatValue = (column, value) => {
        if (!value) return value;
        
        // Check if this is a date field (by column key) and format it as Persian date
        if (column.key.includes('time') || column.key.includes('date')) {
            try {
                return new Date(value).toLocaleDateString("fa-IR");
            } catch (e) {
                return value;
            }
        }
        
        return value;
    };

    return (
        <div className="w-full overflow-x-auto border border-gray-200 dark:border-gray-700 rounded-lg">
            <table className="min-w-full table-auto">
                <thead>
                    <tr className="bg-gray-50 dark:bg-gray-700">
                        {columns.map((column, index) => (
                            <th key={index} className="px-4 py-2 text-right text-sm font-medium text-gray-900 dark:text-gray-100">
                                {column.title}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.length > 0 ? (
                        data.map((row, rowIndex) => (
                            <tr key={rowIndex} className="border-b border-gray-200 dark:border-gray-700">
                                {columns.map((column, colIndex) => (
                                    <td key={colIndex} className="px-4 py-2 text-sm text-gray-900 dark:text-gray-100">
                                        {formatValue(column, row[column.key])}
                                    </td>
                                ))}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={columns.length} className="px-4 py-2 text-center text-sm text-gray-500 dark:text-gray-400">
                                اطلاعاتی یافت نشد
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default function TaroffOrdersView(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formViewTextTitle, setFormViewTextTitle] = useState(null);
    const [formViewTextShopIdTitle, setFormViewTextShopIdTitle] = useState(null);
    const [formViewTextShopCode, setFormViewTextShopCode] = useState(null);
    const [formViewTextStateIdTitle, setFormViewTextStateIdTitle] = useState(null);
    const [formViewTextPaymentMethodIdTitle, setFormViewTextPaymentMethodIdTitle] = useState(null);
    const [formViewTextCarrierIdTitle, setFormViewTextCarrierIdTitle] = useState(null);
    const [formViewTextTotalListPrice, setFormViewTextTotalListPrice] = useState(null);
    const [formViewTextPayablePrice, setFormViewTextPayablePrice] = useState(null);
    const [formViewTextGatewayPayablePrice, setFormViewTextGatewayPayablePrice] = useState(null);
    const [formViewTextPostShippingWithoutCod, setFormViewTextPostShippingWithoutCod] =
        useState('');
    const [formViewTextPostShipping, setFormViewTextPostShipping] = useState(null);
    const [formViewTextPostTax, setFormViewTextPostTax] = useState(null);
    const [formViewTextServicePrice, setFormViewTextServicePrice] = useState(null);
    const [formViewTextPeikPrice, setFormViewTextPeikPrice] = useState(null);
    const [formViewTextOpTimePlan, setFormViewTextOpTimePlan] = useState(null);
    const [formViewTextOpTimeMission, setFormViewTextOpTimeMission] = useState(null);
    const [formViewTextOpTimeCluster, setFormViewTextOpTimeCluster] = useState(null);
    const [formViewTextTotalShippingPrice, setFormViewTextTotalShippingPrice] = useState(null);
    const [formViewTextTotalShippingTax, setFormViewTextTotalShippingTax] = useState(null);
    const [formViewTextPaidShippingPrice, setFormViewTextPaidShippingPrice] = useState(null);
    const [formViewTextPostBarcode, setFormViewTextPostBarcode] = useState(null);
    const [formViewTextGatewayState, setFormViewTextGatewayState] = useState(null);
    const [formViewTextSmsState, setFormViewTextSmsState] = useState(null);
    const [formViewTextCityIdProvinceIdTitle, setFormViewTextCityIdProvinceIdTitle] = useState(null);
    const [formViewTextCityIdTitle, setFormViewTextCityIdTitle] = useState(null);
    const [formViewTextPostCode, setFormViewTextPostCode] = useState(null);
    const [formViewTextAddress, setFormViewTextAddress] = useState(null);
    const [formAttachmentPictureOne, setFormAttachmentPictureOne] = useState(null);
    const [formViewTextTotalWeight, setFormViewTextTotalWeight] = useState(null);
    const [formViewTextBoxSizeTitle, setFormViewTextBoxSizeTitle] = useState(null);
    const [formViewTextPacketTypeIdTitle, setFormViewTextPacketTypeIdTitle] = useState(null);
    
    // States for order related data
    const [stateChanges, setStateChanges] = useState([]);
    const [transactions, setTransactions] = useState([]);
    const [logs, setLogs] = useState([]);
    const [loadingStateChanges, setLoadingStateChanges] = useState(false);
    const [loadingTransactions, setLoadingTransactions] = useState(false);
    const [loadingLogs, setLoadingLogs] = useState(false);
    
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-view/form-data', {
            id: allProps['taroff-orders-id'],
        }).then((response) => {
            setFormViewTextTitle(response.data.text_title);
            setFormViewTextShopIdTitle(response.data.text_shop_id_title);
            setFormViewTextShopCode(response.data.text_shop_code);
            setFormViewTextStateIdTitle(response.data.text_state_id_title);
            setFormViewTextPaymentMethodIdTitle(response.data.text_payment_method_id_title);
            setFormViewTextCarrierIdTitle(response.data.text_carrier_id_title);
            setFormViewTextPacketTypeIdTitle(response.data.text_packet_type_id_title);
            setFormViewTextTotalListPrice(response.data.text_total_list_price);
            setFormViewTextPayablePrice(response.data.text_payable_price);
            setFormViewTextTotalWeight(response.data.text_total_weight);
            setFormViewTextBoxSizeTitle(response.data.text_box_size_title);
            setFormViewTextGatewayPayablePrice(response.data.text_gateway_payable_price);
            setFormViewTextPostShippingWithoutCod(response.data.text_post_shipping_without_cod);
            setFormViewTextPostShipping(response.data.text_post_shipping);
            setFormViewTextPostTax(response.data.text_post_tax);
            setFormViewTextServicePrice(response.data.text_service_price);
            setFormViewTextPeikPrice(response.data.text_peik_price);
            setFormViewTextOpTimePlan(response.data.text_op_time_plan);
            setFormViewTextOpTimeMission(response.data.text_op_time_mission);
            setFormViewTextOpTimeCluster(response.data.text_op_time_cluster);
            setFormViewTextTotalShippingPrice(response.data.text_total_shipping_price);
            setFormViewTextTotalShippingTax(response.data.text_total_shipping_tax);
            setFormViewTextPaidShippingPrice(response.data.text_paid_shipping_price);
            setFormViewTextPostBarcode(response.data.text_post_barcode);
            setFormViewTextGatewayState(response.data.text_gateway_state);
            setFormViewTextSmsState(response.data.text_sms_state);
            setFormViewTextCityIdProvinceIdTitle(response.data.text_city_id_province_id_title);
            setFormViewTextCityIdTitle(response.data.text_city_id_title);
            setFormViewTextPostCode(response.data.text_post_code);
            setFormViewTextAddress(response.data.text_address);
            setFormAttachmentPictureOne(response.data.attachment_picture_one);
        });
        
        // Fetch state changes data
        fetchOrderStateChanges();
        
        // Fetch transactions data
        fetchOrderTransactions();
        
        // Fetch logs data
        fetchOrderLogs();
    }, []);
    
    // Column definitions for tables
    const stateChangesColumns = [
        { key: 'text_id', title: 'شناسه' },
        { key: 'text_old_state_id_title', title: 'وضعیت قبلی' },
        { key: 'text_new_state_id_title', title: 'وضعیت جدید' },
        { key: 'text_insert_time', title: 'تاریخ تغییر' }
    ];
    
    const transactionsColumns = [
        { key: 'text_id', title: 'شناسه' },
        { key: 'text_title', title: 'عنوان' },
        { key: 'text_type_id_title', title: 'نوع تراکنش' },
        { key: 'text_amount', title: 'مبلغ' },
        { key: 'text_shop_title', title: 'فروشگاه' },
        { key: 'text_insert_time', title: 'تاریخ ثبت' }
    ];
    
    const logsColumns = [
        { key: 'text_id', title: 'شناسه' },
        { key: 'text_title', title: 'عنوان' },
        { key: 'text_description', title: 'توضیحات' },
        { key: 'text_insert_time', title: 'تاریخ ثبت' }
    ];
    
    const fetchOrderStateChanges = async () => {
        setLoadingStateChanges(true);
        try {
            const response = await postData('/api/panel/page/taroff-orders-view/state-changes', { 
                id: allProps['taroff-orders-id'],
                size: 100,
                page: 1
            });
            if (response.status === 'success') {
                setStateChanges(response.data.rows || []);
            }
        } catch (error) {
            console.error('Error fetching state changes data:', error);
        } finally {
            setLoadingStateChanges(false);
        }
    };
    
    const fetchOrderTransactions = async () => {
        setLoadingTransactions(true);
        try {
            const response = await postData('/api/panel/page/taroff-orders-view/transactions', { 
                id: allProps['taroff-orders-id'],
                size: 100,
                page: 1
            });
            if (response.status === 'success') {
                setTransactions(response.data.rows || []);
            }
        } catch (error) {
            console.error('Error fetching transactions data:', error);
        } finally {
            setLoadingTransactions(false);
        }
    };
    
    const fetchOrderLogs = async () => {
        setLoadingLogs(true);
        try {
            const response = await postData('/api/panel/page/taroff-orders-view/logs', { 
                id: allProps['taroff-orders-id'],
                size: 100,
                page: 1
            });
            if (response.status === 'success') {
                setLogs(response.data.rows || []);
            }
        } catch (error) {
            console.error('Error fetching logs data:', error);
        } finally {
            setLoadingLogs(false);
        }
    };
    
    return (
        <PanelBox>
            <DataForm>
                <Grid>
                    <GridColumn width={12}>
                        <Grid>
                            <GridColumn width={4}>
                                <LabeledTextView label={'عنوان سفارش'}>
                                    {formViewTextTitle}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}>
                                <LabeledTextView label={'عنوان فروشگاه سفارش'}>
                                    {formViewTextShopIdTitle}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}>
                                <LabeledTextView label={'کد رهگیری در فروشگاه سفارش'}>
                                    {formViewTextShopCode}
                                </LabeledTextView>
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={4}>
                                <LabeledTextView label={'عنوان وضعیت سفارش'}>
                                    {formViewTextStateIdTitle}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}>
                                <LabeledTextView label={'عنوان شیوه ی پرداخت سفارش'}>
                                    {formViewTextPaymentMethodIdTitle}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}>
                                <LabeledTextView label={'عنوان حامل سفارش'}>
                                    {formViewTextCarrierIdTitle}
                                </LabeledTextView>
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={4}>
                                <LabeledTextView label={'مبلغ کل سفارش'}>
                                    {formViewTextTotalListPrice}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}>
                                <LabeledTextView label={'مبلغ قابل پرداخت سفارش'}>
                                    {formViewTextPayablePrice}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}>
                                <LabeledTextView label={'مبلغ قابل پرداخت گیت وی سفارش'}>
                                    {formViewTextGatewayPayablePrice}
                                </LabeledTextView>
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={4}>
                                <LabeledTextView label={'هزینه ارسال پست کسر COD سفارش'}>
                                    {formViewTextPostShippingWithoutCod}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}>
                                <LabeledTextView label={'هزینه ارسال پست سفارش'}>
                                    {formViewTextPostShipping}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}>
                                <LabeledTextView label={'هزینه مالیات پست سفارش'}>
                                    {formViewTextPostTax}
                                </LabeledTextView>
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={4}>
                                <LabeledTextView label={'هزینه خدمات سفارش'}>
                                    {formViewTextServicePrice}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}>
                                <LabeledTextView label={'هزینه پیک سفارش'}>
                                    {formViewTextPeikPrice}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}></GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={4}>
                                <LabeledTextView label={'پلن آپتایم سفارش'}>
                                    {formViewTextOpTimePlan}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}>
                                <LabeledTextView label={'ماموریت آپتایم سفارش'}>
                                    {formViewTextOpTimeMission}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}>
                                <LabeledTextView label={'کلاستر آپتایم سفارش'}>
                                    {formViewTextOpTimeCluster}
                                </LabeledTextView>
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={4}></GridColumn>
                            <GridColumn width={4}></GridColumn>
                            <GridColumn width={4}></GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={4}>
                                <LabeledTextView label={'کل هزینه ارسال سفارش'}>
                                    {formViewTextTotalShippingPrice}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}>
                                <LabeledTextView label={'کل مالیات ارسال سفارش'}>
                                    {formViewTextTotalShippingTax}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}>
                                <LabeledTextView label={'هزینه ارسال پرداخت شده سفارش'}>
                                    {formViewTextPaidShippingPrice}
                                </LabeledTextView>
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <LabeledTextView label={'بارکد پستی سفارش'}>
                                    {formViewTextPostBarcode}
                                </LabeledTextView>
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <LabeledTextView label={'وضعیت در گیت وی سفارش'}>
                                    {formViewTextGatewayState}
                                </LabeledTextView>
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <LabeledTextView label={'وضعیت پیامک سفارش'}>
                                    {formViewTextSmsState}
                                </LabeledTextView>
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={4}>
                                <LabeledTextView label={'استان'}>
                                    {formViewTextCityIdProvinceIdTitle}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}>
                                <LabeledTextView label={'شهر'}>
                                    {formViewTextCityIdTitle}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}>
                                <LabeledTextView label={'کد پستی سفارش'}>
                                    {formViewTextPostCode}
                                </LabeledTextView>
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <LabeledTextView label={'آدرس سفارش'}>
                                    {formViewTextAddress}
                                </LabeledTextView>
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={4}>
                                <LabeledTextView label={'وزن کل سفارش'}>
                                    {formViewTextTotalWeight}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}>
                                <LabeledTextView label={'اندازه جعبه'}>
                                    {formViewTextBoxSizeTitle}
                                </LabeledTextView>
                            </GridColumn>
                            <GridColumn width={4}>
                                <LabeledTextView label={'نوع بسته'}>
                                    {formViewTextPacketTypeIdTitle}
                                </LabeledTextView>
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <h3>تغییر وضعیت ها</h3>
                                {loadingStateChanges ? (
                                    <div>در حال بارگذاری...</div>
                                ) : stateChanges.length > 0 ? (
                                    <DataTable 
                                        columns={stateChangesColumns} 
                                        data={stateChanges} 
                                        pagination={false}
                                    />
                                ) : (
                                    <div>هیچ تغییر وضعیتی برای این سفارش ثبت نشده است</div>
                                )}
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <PictureUpload
                                    label={'تصویر پیوست یک'}
                                    value={formAttachmentPictureOne}
                                    onChange={setFormAttachmentPictureOne}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <h3>تراکنش ها</h3>
                                {loadingTransactions ? (
                                    <div>در حال بارگذاری...</div>
                                ) : transactions.length > 0 ? (
                                    <DataTable 
                                        columns={transactionsColumns} 
                                        data={transactions} 
                                        pagination={false}
                                    />
                                ) : (
                                    <div>هیچ تراکنشی برای این سفارش ثبت نشده است</div>
                                )}
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <h3>سابقه ها</h3>
                                {loadingLogs ? (
                                    <div>در حال بارگذاری...</div>
                                ) : logs.length > 0 ? (
                                    <DataTable 
                                        columns={logsColumns} 
                                        data={logs} 
                                        pagination={false}
                                    />
                                ) : (
                                    <div>هیچ سابقه‌ای برای این سفارش ثبت نشده است</div>
                                )}
                            </GridColumn>
                        </Grid>
                    </GridColumn>
                </Grid>
                <Button onClick={handlecomp1}>بستن</Button>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
